import React from "react";
import "assets/scss/helpers/buttons.scss";
import classNames from "classnames";
export default function ({
  onClick,
  name,
  type = "button",
  disabled = false,
  buttonStyle,
  children,
  buttonClass = "fab-button add",
}) {
  const buttonClasses = classNames({
    btn: true,
    [buttonClass]: true,
  });

  return (
    <button
      style={buttonStyle}
      disabled={disabled}
      className={buttonClasses}
      onClick={onClick}
      type={type}
    >
      {name || children}
    </button>
  );
}
